import request from '../../utils/request';

export function getTraceLogs(params) {
  return request(`/trace-logs`, {
    method: 'GET',
    params,
  });
}

export function getTraceLogOrphans(params) {
  return request(`/trace-logs/orphan`, {
    method: 'GET',
    params,
  });
}
